import { useEffect } from "react";
import { useParams } from "react-router-dom";
import EditLeadForm from "./editEstateAdminstration";
import GrantApplications from "./editGrantApplications";
import LastingPowerOfAttorney from "./editLastingPowersOfAttorneys";
//import LssLastingPowerOfAttorneys from "./editLssLastingPowersOfAttorneys";
//import LsseStateAdmins from "./editLssEstateAdminstration";
//import LssGrantApplications from "./editLssGrantApplications";
import LssWills from "./editLssWills";
import Wills from "./editWills";
import EditConveyancing from "./editConveyancing";


export default function EditProductLeadView() {

  const { slug, product_id, lead_id } = useParams();
  console.log("🔀 PRODUCT-LEAD-EDIT.JSX LOADED");
  console.log("slug@123", slug);
  console.log("🔀 All params:", { slug, product_id, lead_id });
  console.log("🔀 URL:", window.location.href);
  
  console.log("🔀 ROUTING DECISIONS:");
  console.log("  - slug === 'estate-administration':", slug === "estate-administration");
  console.log("  - slug === 'grant-application':", slug === "grant-application"); 
  console.log("  - slug === 'lasting-powers-of-attorney':", slug === "lasting-powers-of-attorney");
  console.log("  - slug === 'conveyancing':", slug === "conveyancing");
  
  console.log("🔀 WHICH COMPONENT WILL RENDER?");
  if (slug === "conveyancing") {
    console.log("✅ EditConveyancing will render (SIMPLE FORM)");
  } else {
    console.log("❌ EditConveyancing will NOT render, slug is:", slug);
  }

  return (
    <>
      {slug === "estate-administration" && <EditLeadForm />}
      {slug === "grant-application" && <GrantApplications/>}
      {slug === "lasting-powers-of-attorney" && <LastingPowerOfAttorney/>}
      {slug === "conveyancing" && <EditConveyancing />}
      {/* {slug === "lss-lasting-powers-of-attorney" && <LssLastingPowerOfAttorneys />} */}
      {/* {slug === "lss-estate-adminstration" && <LsseStateAdmins/>}
      {slug === "lss-grant-application" && <LssGrantApplications/>}
      {slug === "lss-will" && <LssWills />}
      {slug === "wills" && <Wills />} */}
    </>
  );
}
